import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    error: '/img/not-image.jpg',
    loading: '/img/loading.gif',
})
